var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgWalletNavbar = function SvgWalletNavbar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.535 4.083A2.628 2.628 0 0 0 2.91 6.708v3.208h7.03c.342 0 .671-.12.934-.338l3.411-2.843-2.291-1.91a3.214 3.214 0 0 0-2.053-.742H5.535ZM16.703 7l-4.709 3.922a3.213 3.213 0 0 1-2.053.744H2.91v9.042a2.628 2.628 0 0 0 2.624 2.625H23.62a2.628 2.628 0 0 0 2.625-2.625V9.625A2.628 2.628 0 0 0 23.619 7h-6.916Zm2.542 3.5c.483 0 .875.391.875.875v.357c.732.157 1.31.599 1.657 1.292a.876.876 0 0 1-1.566.784c-.102-.203-.255-.392-.697-.392h-.495c-.418 0-.785.341-.785.73 0 .401.327.729.73.729h.717a2.482 2.482 0 0 1 2.48 2.479 2.478 2.478 0 0 1-2.043 2.435v.336a.875.875 0 1 1-1.75 0v-.315a2.49 2.49 0 0 1-1.949-1.335.876.876 0 0 1 1.566-.784c.032.065.22.392.698.392h.998a.73.73 0 0 0 .001-1.458h-.718a2.482 2.482 0 0 1-2.479-2.48c0-1.123.815-2.09 1.885-2.38v-.39c0-.484.392-.875.875-.875Z",
    fill: "#BFC3D1"
  })));
};

export default SvgWalletNavbar;